import api from "~/api/api.js";
import {User as UserEntity} from "~/dto/User";

export class User {

    static async getInfo() {
        try {
            const data = await api("/profile/info");
            // Сюда можно попасть и без Id/Token в localStorage этого поддомена —
            // бэкенд опознал по общей cookie (SESSION_DOMAIN=.sharun.store).
            // Сохраняем токен здесь же, чтобы дальнейшие запросы на этом
            // поддомене шли обычным путём (заголовками), не завися от cookie.
            if (process.client && !localStorage.getItem("Token") && data?.token) {
                localStorage.setItem("Id", data.id);
                localStorage.setItem("Token", data.token);
            }
            return UserEntity.createFromObj(data);
        } catch {
            return null;
        }
    }

    /**
     *
     * @return {Promise<number>}
     */
    static getBonuses() {
        return api("/profile/bonuses");
    }

}